import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./MobileNavbar.css"; // Você criará este arquivo CSS

// Importações dos ícones mantidas conforme original



import bulletPoupancaImg from "../../images/side_bar/poupancas.svg";
import bulletProtecaoImg from "../../images/side_bar/protecao.svg";
import protecao_poupanca from "../../images/protecao-poupanca.svg"

import bulletHomeImg from "../../images/side_bar/MyMontepio.svg";
import bulletBeneficiosImg from "../../images/side_bar/beneficios.svg";
import bulletModalImg from "../../images/side_bar/modalidades.svg";

const MobileNavbar = () => {
    // Controle menu open
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <div className="mobile-navbar-container">
            <div className={`bottom-drawer ${menuOpen ? "bottom-drawer--open" : ""}`}>
                <div className="bottom-drawer__overlay" onClick={() => setMenuOpen(!menuOpen)} />
                <div className="bottom-drawer__content">
                    <h5>Modalidades</h5>
                    <div className="mobile-navbar-list">
                        <ul>
                            <li>
                                <NavLink exact activeClassName="active" className="link" to="/poupanca"
                                    onClick={(event) => {
                                        window.history.replaceState(null, "", "/poupanca");
                                        setMenuOpen(!menuOpen);
                                    }}>
                                    <img
                                        src={bulletPoupancaImg}
                                        alt=""
                                        height="24px"
                                        width="24px"></img>
                                    <span className="item_label_mobile" style={{ marginLeft: "1em" }}>Poupança</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact activeClassName="active" className="link" to="/protecao"
                                    onClick={(event) => {
                                        window.history.replaceState(null, "", "/protecao");
                                        setMenuOpen(!menuOpen);
                                    }}>
                                    <img
                                        src={bulletProtecaoImg}
                                        alt=""
                                        height="24px"
                                        width="24px"></img>
                                    <span className="item_label_mobile" style={{ marginLeft: "1em" }}>Proteção</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact activeClassName="active" className="link" to="/protecao_poupanca"
                                    onClick={(event) => {
                                        window.history.replaceState(null, "", "/protecao_poupanca");
                                        setMenuOpen(!menuOpen);
                                    }}>
                                    <img
                                        src={protecao_poupanca}
                                        alt=""
                                        height="24px"
                                        width="24px"></img>
                                    <span className="item_label_mobile" style={{ marginLeft: "1em" }}>Poupança + Proteção</span>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <nav className="mobile-navbar">
                <div className="nav-item-container">
                    <NavLink exact activeClassName="active" className="nav-item" to="/">
                        <img src={bulletHomeImg} alt="Home" height="26px" width="26px" />
                        <span className="item_label" >Montepio</span>
                    </NavLink>

                </div>

                <div className="nav-item-container">
                    <NavLink exact activeClassName="active" className="nav-item" to="/beneficios">
                        <img src={bulletBeneficiosImg} alt="Benefícios" height="26px" width="26px" />
                        <span className="item_label" >Benefícios</span>
                    </NavLink>
                </div>
                <div className="nav-item-container">
                    <div className="nav-item" onClick={() => setMenuOpen(!menuOpen)}>
                        <img src={bulletModalImg} alt="Modalidades" height="26px" width="26px" />
                        <span className="item_label" >Modalidades</span>
                    </div>
                </div>
                {/* <div className="nav-item-container">
                <div className="nav-item" onClick={() => alert("Abrir Menu de Mais")}>
                    <img src={bulletMenuMoreImg} alt="Modalidades" height="26px" width="26px" />
                    <span className="item_label" >Mais</span>
                </div>
            </div> */}

            </nav >
        </div>

    );
};

export default MobileNavbar;